import { render, staticRenderFns } from "./baseCollection.vue?vue&type=template&id=906e9dbc&"
import script from "@viewJs/examRegisteation/baseCollection.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/baseCollection.js?vue&type=script&lang=js&"
import style0 from "./baseCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports